(function () {
	const _calendar = document.getElementById('calendar');
	
	if (!_calendar) {
		return;
	}
	
	const _events = document.getElementById('calendar-events');
	const _prevButton = document.getElementById('calendar-prev-button');
	const _nextButton = document.getElementById('calendar-next-button');
	const _currentMonth = document.getElementById('calendar-current-month');
	const _dates = document.getElementById('calendar-dates');
	
	function load() {
		util.ajax('/programok/naptar', {
			data: (arguments[0] ? 'month=' + arguments[0] : ''),
			
			onsuccess: (response) => {
				_currentMonth.innerHTML = response.current_month;
				_dates.innerHTML = response.dates;
				_prevButton.value = response.prev_month;
				_nextButton.value = response.next_month;
			},
		});
	}
	
	_prevButton.addEventListener('click', () => {
		load(_prevButton.value);
	});
	
	_nextButton.addEventListener('click', () => {
		load(_nextButton.value);
	});
	
	_calendar.addEventListener('click', function (event) {
		if (!util.hasClass(event.target, 'js-calendar-date-button')) {
			return;
		}
		
		util.ajax('/programok/' + event.target.getAttribute('data-date'), {
			onsuccess: (response) => {
				_events.innerHTML = response;
				
				const _firstLink = _events.querySelector('a');
				
				if (_firstLink) {
					_firstLink.focus();
				}
			},
		});
	});
	
	load();
}());